export const COMPANY_DATA_FETCH_INIT = 'COMPANY_DATA_FETCH_INIT';
export const COMPANY_DATA_FETCH_SUCCESS = 'COMPANY_DATA_FETCH_SUCCESS';
export const COMPANY_DATA_FETCH_ERROR = 'COMPANY_DATA_FETCH_ERROR';

export const COMPANY_DATA_POST_INIT = 'COMPANY_DATA_POST_INIT';
export const COMPANY_DATA_POST_SUCCESS = 'COMPANY_DATA_POST_SUCCESS';
export const COMPANY_DATA_POST_ERROR = 'COMPANY_DATA_POST_ERROR';

export const COMPANY_DATA_RESET = 'COMPANY_DATA_RESET';
